import { isSmartViewWidget } from "../../../models/isTileObjectSmartView.ts";
import type { CopyCompanyDashboard, CopyCompanyTile } from "../../hooks/CopyCompany.ts";
import { ArbitraryTileItemCopying } from "./ArbitraryTileItemCopying.tsx";
import { SmartViewTileItemCopying } from "./SmartViewTileItemCopying.tsx";

interface Props {
  tile: CopyCompanyTile;
  dashboard: CopyCompanyDashboard;
}

export const TileItemCopying = ({ tile, dashboard }: Props) => {
  if (isSmartViewWidget(tile.tile.tile.widget)) {
    return <SmartViewTileItemCopying tile={tile} dashboard={dashboard} />;
  }
  return <ArbitraryTileItemCopying tile={tile} />;
};
